import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

const Grid = observer(({
  style = {},
  children,
  className = '',
  settings,
  compactType,
  maxY,
  ...props
}) => {
  const maxW = settings && settings.MAX_W ? settings.MAX_W : 48
  const rowH = settings && settings.ROW_HEIGHT ? settings.ROW_HEIGHT : 20
  return (
    <div
      className={cn('Grid', className)}
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${maxW}, 1fr)`,
        gridAutoRows: compactType ? 'auto' : `${rowH}px`,
        //        overflowY: 'auto',
        height: compactType ? 'auto' : '100%',
        ...style
      }}
      {...props}
    >
      {children}

    </div>
  )
})

export default Grid
